const featureConfigNode = document.getElementById('hdt-feature-modules');
const featureImports = new Map();

function read_feature_modules_fn() {
  try {
    return JSON.parse(featureConfigNode?.textContent || '{}').modules || [];
  } catch (error) {
    console.error('[hdt-feature-loader] Invalid feature configuration', error);
    return [];
  }
}

const featureModules = read_feature_modules_fn();

function feature_root_matches_fn(root, selector) {
  if (!root || !selector) return false;
  return Boolean(root.matches?.(selector) || root.querySelector?.(selector));
}

function import_feature_module_fn(feature) {
  if (!feature?.url || featureImports.has(feature.url)) return;
  const request = import(feature.url).catch((error) => {
    console.error(`[hdt-feature-loader] Failed to load ${feature.name || feature.url}`, error);
  });
  featureImports.set(feature.url, request);
}

function scan_feature_modules_fn(root = document) {
  featureModules.forEach((feature) => {
    if (feature_root_matches_fn(root, feature.selector)) import_feature_module_fn(feature);
  });
}

function scan_feature_event_fn(event) {
  scan_feature_modules_fn(event.target || document);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => scan_feature_modules_fn(document), { once: true });
} else {
  scan_feature_modules_fn(document);
}

document.addEventListener('shopify:section:load', scan_feature_event_fn);
document.addEventListener('products:update', scan_feature_event_fn);
document.addEventListener('dialog:opening', scan_feature_event_fn, { capture: true });
